import React from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import { useExtensionContext } from "../ExtensionContext";
import { toast } from "react-toastify";
import useEditDeal from "app/popleads/hooks/useEditDeal";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import styled from "styled-components";
import moment from "moment";
import {
    POPUP_CONTENTS,
    publicTypes,
    DEAL_WON,
    DEAL_LOST,
    DEAL_CANCELLED,
    inHouseTypes,
    inquiryTypes,
} from "../utils/constants";
const StyledDealActions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;
export const DealFooter = () => {
    const {
        setState,
        modals,
        selectedDeal,
        isDealEditing,
        setIsDealEditing,
        dealObject,
        initialDealObject,
        setDealObject,
        createRegisterInHouseActivityURL,
        createRegisterELearningActivityURL,
        createActivityURL,
        refetchProfile,
    } = useExtensionContext();

    const { editDeal, loading: editDealLoading } = useEditDeal();
    const isRegisteredDeal = selectedDeal?.invoiceRequisitionId || selectedDeal?.invoiceRequisitionActivityId;
    const willRegisterInHouseDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        (selectedDeal?.dealCampaignType === "In-house" || selectedDeal?.dealCampaignType === "LVT In-house") &&
        !isRegisteredDeal;

    const willRegisterELearningDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        (selectedDeal?.dealCampaignType === "E-Learning" || selectedDeal?.dealCampaignType === "EdTech") &&
        !isRegisteredDeal;

    const willRegisterConsultingDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        selectedDeal?.dealCampaignType === "Consulting" &&
        !isRegisteredDeal;

    const willRegisterCoachingDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        selectedDeal?.dealCampaignType === "Coaching" &&
        !isRegisteredDeal;

    const willCreateInvoiceRequisition =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        publicTypes.includes(selectedDeal?.dealCampaignType) &&
        !isRegisteredDeal;

    const handleCancelEdit = () => {
        setIsDealEditing(false);
    };

    const handleClick = async () => {
        if (!selectedDeal) return;

        if (willRegisterInHouseDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterInHouseActivityURL(selectedDeal.profilId, dealObject);
            window.open(url, "_self");
        } else if (willRegisterELearningDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(selectedDeal.profilId, dealObject, "eLearning Confirmation");
            window.open(url, "_self");
        } else if (willRegisterConsultingDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(
                selectedDeal.profilId,
                dealObject,
                "Consulting Confirmation"
            );
            window.open(url, "_self");
        } else if (willRegisterCoachingDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(selectedDeal.profilId, dealObject, "Coaching Confirmation");
            window.open(url, "_self");
        } else if (willCreateInvoiceRequisition) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createActivityURL(selectedDeal.profilId, dealObject);
            window.open(url, "_self");
        } else if (isDealEditing) {
            const kapanmaTarihi = dealObject?.kapanmaTarihi || dealObject?.closingDate;

            if (!dealObject.amount) {
                toast.error("You need to enter the amount first");
                return true;
            }

            if (
                dealObject?.campaign?.type === "Public-ExEd" &&
                parseFloat(dealObject.amount) > parseFloat(dealObject.campaign.fullPrice)
            ) {
                toast.error("Deal amount can not be higher than campaign full price!");
                return false;
            }
            if (!dealObject.closingDate && [DEAL_WON, DEAL_LOST, DEAL_CANCELLED].includes(dealObject.status)) {
                toast.error("Please choose a closing date");
                return false;
            }
            if (!dealObject.type && dealObject.status === DEAL_WON) {
                toast.error("You need to enter the type first");
                return false;
            }

            if (!dealObject.accountName?.trim()) {
                toast.error("You need to enter an account name");
                return;
            }

            if (!dealObject.channelType && ["Marketing", "Marketing Cross Sale"].includes(dealObject.type)) {
                toast.error("Please select marketing channel");
                return false;
            }

            if (dealObject.campaign && moment(kapanmaTarihi).year() !== moment(dealObject?.campaign?.basTarih).year()) {
                toast.error("Your closing date year must be the same as the campaign year");
                return;
            }
            // if (
            //     inHouseTypes.includes(dealObject?.dealCampaignType) &&
            //     dealObject?.courseName === "newCourseName" &&
            //     dealObject?.newCourseName === undefined
            // ) {
            //     toast.error("You need to enter new course name.");
            // }
            if (dealObject?.durum === DEAL_WON && publicTypes.includes(dealObject?.dealCampaignType)) {
                if (kapanmaTarihi && moment(kapanmaTarihi).year() !== moment(dealObject?.campaign?.basTarih).year()) {
                    toast.error("Your closing date year must be the same as the campaign year");
                    return;
                }

                if (
                    dealObject?.campaign?.type === "L&D Broker" ||
                    dealObject?.campaign?.type === "Public-ExEd" ||
                    dealObject?.campaign?.type === "Public" ||
                    dealObject?.campaign?.type === "LVT Public"
                ) {
                    if (!dealObject.certificateName || dealObject.certificateName.trim() === "") {
                        toast.error("Please provide a certificate name");
                        return;
                    }
                    if (!dealObject.certificateLastName || dealObject.certificateLastName.trim() === "") {
                        toast.error("Please provide a certificate lastname");
                        return;
                    }
                }
            }

            if (
                dealObject?.durum === DEAL_WON &&
                (inHouseTypes.includes(dealObject?.dealCampaignType) ||
                    inquiryTypes.includes(dealObject?.dealCampaignType))
            ) {
                if (!dealObject?.courseName?.trim()) {
                    switch (dealObject.dealCampaignType) {
                        case "E-Learning":
                        case "EdTech":
                            toast.error("You need to select an e-learning bundles from the list.");
                            break;
                        case "Consulting":
                            toast.error("You need to select a consulting type from the list.");
                            break;
                        case "Coaching":
                            toast.error("You need to select a coaching type from the list.");
                            break;
                        default:
                            toast.error("You need to enter a course name");
                            break;
                    }
                    return;
                }

                if (dealObject?.courseName === "newCourseName") {
                    if (!dealObject?.newCourseName?.trim()) {
                        switch (dealObject.dealCampaignType) {
                            case "E-Learning":
                            case "EdTech":
                                toast.error("You need to enter new e-learning bundles.");
                                break;
                            case "Consulting":
                                toast.error("You need to enter new consulting type.");
                                break;
                            case "Coaching":
                                toast.error("You need to enter new coaching type.");
                                break;
                            default:
                                toast.error("You need to enter new course name.");
                                break;
                        }
                        return;
                    }
                }
            }

            try {
                await editDeal(dealObject);
                await refetchProfile();
                toast.success("Deal updated successfully");
                setIsDealEditing(false);
                //setSelectedDeal(null);
            } catch (error) {
                toast.error(error || "Failed to update deal");
            }
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <StyledDealActions>
                {!isDealEditing && (
                    <>
                        <OverlayTrigger placement="top" overlay={<Tooltip>Create New Potential</Tooltip>}>
                            <span>
                                <ButtonWithLabel
                                    variant="primary"
                                    buttonStyle="default"
                                    size="circle"
                                    icon={"add"}
                                    iconType={"material"}
                                    onClick={() => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            popupContent: POPUP_CONTENTS.NEW_DEAL,
                                        }));
                                        setDealObject(initialDealObject);
                                    }}
                                />
                            </span>
                        </OverlayTrigger>
                        {selectedDeal && (
                            <>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="primary"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"edit"}
                                        iconType={"material"}
                                        onClick={() => {
                                            setIsDealEditing(true);
                                        }}
                                    />
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Transfer Deal</Tooltip>}>
                                    <span>
                                        <ButtonWithLabel
                                            variant="primary"
                                            buttonStyle="default"
                                            size="circle"
                                            icon={"move_up"}
                                            iconType={"material"}
                                            onClick={() =>
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    popupContent: POPUP_CONTENTS.TRANSFER_DEAL,
                                                }))
                                            }
                                        />
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Create An Another Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="primary"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"content_copy"}
                                        iconType={"material"}
                                        onClick={() => {
                                            if (selectedDeal) {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    popupContent: POPUP_CONTENTS.NEW_DEAL,
                                                    selectedCampaignStartDate: selectedDeal.kapanmaTarihi || new Date(),
                                                }));
                                                setDealObject({
                                                    ...dealObject,
                                                    courseName: null,
                                                    paidAmount: "0",
                                                    amount: null,
                                                    certificateName: "",
                                                    certificateLastName: "",
                                                    createAnotherDeal: true,
                                                });
                                            }
                                        }}
                                    />
                                </OverlayTrigger>

                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="danger"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"delete"}
                                        iconType={"material"}
                                        onClick={() => {
                                            if (selectedDeal?.durum === "Won") {
                                                setState({ selectedModal: modals.DELETE_BASED_ON_STATUS });
                                            } else {
                                                setState({ selectedModal: modals.DELETE_DEAL });
                                            }
                                        }}
                                    />
                                </OverlayTrigger>
                            </>
                        )}
                    </>
                )}
            </StyledDealActions>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center" }}>
                {isDealEditing && (
                    <ButtonWithText
                        variant="danger"
                        disabled={editDealLoading}
                        buttonStyle="borderless"
                        size="small"
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </ButtonWithText>
                )}
                {(isDealEditing ||
                    willRegisterInHouseDeal ||
                    willRegisterELearningDeal ||
                    willRegisterConsultingDeal ||
                    willRegisterCoachingDeal ||
                    willCreateInvoiceRequisition) && (
                    <ButtonWithText
                        variant="primary"
                        buttonStyle="default"
                        type="default"
                        size="small"
                        disabled={editDealLoading}
                        onClick={handleClick}
                    >
                        {willRegisterCoachingDeal ||
                        willRegisterInHouseDeal ||
                        willRegisterELearningDeal ||
                        willRegisterConsultingDeal
                            ? "Register Deal"
                            : willCreateInvoiceRequisition
                            ? "Create Invoice Requisition"
                            : "Save"}
                        {isDealEditing && editDealLoading && (
                            <Spinner animation="border" className="ml-1" variant="light" size="sm" />
                        )}
                    </ButtonWithText>
                )}
            </div>
        </div>
    );
};
